module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-ppp.jpg?v=b75678fd";